import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSiteSettings } from '../hooks/useSiteSettings';
import { useAnyModalOpen } from '../hooks/useModalOpen';
import { trackContact } from '../utils/analytics';

/**
 * Floating WhatsApp button — bottom-right, always visible on public pages.
 * Uses `settings.whatsapp` (E.164 without '+', e.g. "908504959524") from
 * site settings, falls back to the default in useSiteSettings.
 * Hidden on admin routes.
 */
const WhatsAppButton = () => {
  const { pathname } = useLocation();
  const settings = useSiteSettings();
  const modalOpen = useAnyModalOpen();

  if (pathname.startsWith('/admin') || modalOpen) return null;

  const raw = settings.whatsapp || '908504959524';
  const number = String(raw).replace(/[^0-9]/g, '');
  const text = encodeURIComponent('Merhaba, Camption turları hakkında bilgi almak istiyorum.');
  const href = `https://wa.me/${number}?text=${text}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackContact({ content_name: 'WhatsApp Float Button', method: 'whatsapp' })}
      data-testid="whatsapp-float-button"
      aria-label="WhatsApp ile iletişime geç"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30 group-hover:opacity-0" />
      <span className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300">
        {/* WhatsApp glyph (inline SVG, no icon lib) */}
        <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.226 1.36.194 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
          <path d="M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.334.101 11.892c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652c1.746.943 3.71 1.444 5.71 1.447h.005c6.582 0 11.941-5.335 11.944-11.896 0-3.18-1.26-6.167-3.474-8.45zM12.05 21.785h-.004a9.87 9.87 0 01-5.031-1.378l-.36-.214-3.741.982 1.001-3.635-.235-.375a9.86 9.86 0 01-1.51-5.26c.002-5.45 4.455-9.882 9.945-9.882 2.654 0 5.148 1.033 7.022 2.906 1.874 1.874 2.905 4.367 2.904 7.019-.003 5.45-4.456 9.884-9.945 9.884z"/>
        </svg>
      </span>
    </a>
  );
};

export default WhatsAppButton;
